// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import useUuid from '../../../../../hooks/useUuid';

const RedCard = styled.g``;
const BlueCard = styled.g``;
const OrangeCard = styled.g``;

const CardInnerShadow = styled.g`
  mix-blend-mode: soft-light;
`;

type MPCardProgressSvgAsComponentProps = {
  className?: string;
  key?: string;
};

const MPCardProgressSvgAsComponent = ({ className, key }: MPCardProgressSvgAsComponentProps) => {
  const uuid = useUuid();
  // eslint-disable-next-line sonarjs/no-nested-template-literals
  const uniqueIdentifier = `${uuid}${key ? `__${key}` : ''}`;

  return (
    <svg className={className} viewBox="0 0 34 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <RedCard filter={`url(#background-red-card-shadow-${uniqueIdentifier})`}>
        <path
          d="M1.13242 4.02656C1.14046 2.97824 2.00589 2.13487 3.06543 2.14282L12.6577 2.21482C13.7172 2.22277 14.5696 3.07905 14.5616 4.12736L14.4437 19.5023C14.4357 20.5506 13.5702 21.394 12.5107 21.386L2.91843 21.314C1.85889 21.3061 1.00649 20.4498 1.01453 19.4015L1.13242 4.02656Z"
          fill="white"
        />
        <path
          d="M1.13242 4.02656C1.14046 2.97824 1.99386 2.13477 3.03856 2.14262L12.6857 2.21503C13.7303 2.22287 14.5707 3.07906 14.5627 4.12737L14.4462 19.3125C14.4382 20.3608 13.5848 21.2043 12.5401 21.1964L2.89301 21.124C1.84832 21.1162 1.00794 20.26 1.01598 19.2117L1.13242 4.02656Z"
          fill={`url(#linear-gradient-0-${uniqueIdentifier})`}
          fillOpacity="0.4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.6562 2.40463L3.06397 2.33263C2.11039 2.32547 1.3315 3.08452 1.32426 4.028L1.20637 19.4029C1.19914 20.3464 1.9663 21.1171 2.91988 21.1242L12.5122 21.1962C13.4657 21.2034 14.2446 20.4443 14.2519 19.5009L14.3698 4.12592C14.377 3.18244 13.6098 2.41179 12.6562 2.40463ZM3.06543 2.14282C2.00589 2.13487 1.14046 2.97824 1.13242 4.02656L1.01453 19.4015C1.00649 20.4498 1.85889 21.3061 2.91843 21.314L12.5107 21.386C13.5702 21.394 14.4357 20.5506 14.4437 19.5023L14.5616 4.12736C14.5696 3.07905 13.7172 2.22277 12.6577 2.21482L3.06543 2.14282Z"
          fill={`url(#linear-gradient-1-${uniqueIdentifier})`}
        />
        <path
          d="M1.13242 4.02656C1.14046 2.97825 2.00589 2.13487 3.06543 2.14282L12.6577 2.21482C13.7172 2.22277 14.5696 3.07905 14.5616 4.12736L14.5321 7.98059L1.10287 7.87978L1.13242 4.02656Z"
          fill="#E1242E"
        />
        <CardInnerShadow>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.6533 2.78426L3.06106 2.71226C2.31939 2.70669 1.71358 3.29706 1.70795 4.03088L1.68278 7.31466L13.9609 7.40682L13.9861 4.12304C13.9917 3.38922 13.395 2.78983 12.6533 2.78426ZM3.06543 2.14282C2.00589 2.13487 1.14046 2.97824 1.13242 4.02656L1.10287 7.87978L14.5321 7.98059L14.5616 4.12736C14.5696 3.07905 13.7172 2.22277 12.6577 2.21482L3.06543 2.14282Z"
            fill={`url(#linear-gradient-2-${uniqueIdentifier})`}
          />
        </CardInnerShadow>
        <CardInnerShadow>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.92474 20.5551L12.517 20.6271C13.1527 20.6318 13.672 20.1258 13.6768 19.4968L13.7234 13.4228L1.82897 13.3335L1.7824 19.4075C1.77757 20.0365 2.28902 20.5503 2.92474 20.5551ZM12.5126 21.1965C13.4662 21.2037 14.2451 20.4446 14.2524 19.5011L14.3033 12.8577L1.2578 12.7597L1.20686 19.4032C1.19963 20.3467 1.96679 21.1174 2.92037 21.1245L12.5126 21.1965Z"
            fill={`url(#linear-gradient-3-${uniqueIdentifier})`}
          />
        </CardInnerShadow>
        <path d="M1.10303 7.87988L14.5322 7.98069L14.5273 8.61973L1.09813 8.51892L1.10303 7.87988Z" fill="#7B1319" />
        <path d="M1.10645 7.4541L14.5356 7.55491L14.5324 7.98093L1.10318 7.88013L1.10645 7.4541Z" fill="#F8787E" />
      </RedCard>
      <OrangeCard filter={`url(#background-orange-card-shadow-${uniqueIdentifier})`}>
        <path
          d="M21.2885 6.2088C21.9474 5.38776 23.1542 5.2506 23.984 5.90245L31.4967 11.8039C32.3265 12.4557 32.4652 13.6497 31.8063 14.4708L22.1437 26.5125C21.4849 27.3335 20.2781 27.4707 19.4483 26.8188L11.9355 20.9174C11.1057 20.2656 10.9671 19.0716 11.6259 18.2505L21.2885 6.2088Z"
          fill="white"
        />
        <path
          d="M21.2885 6.2088C21.9474 5.38776 23.1447 5.2432 23.9629 5.88592L31.5186 11.8211C32.3368 12.4638 32.466 13.6504 31.8072 14.4714L22.2638 26.3645C21.605 27.1855 20.4076 27.3301 19.5894 26.6874L12.0338 20.7522C11.2156 20.1095 11.0864 18.9229 11.7452 18.1019L21.2885 6.2088Z"
          fill={`url(#linear-gradient-4-${uniqueIdentifier})`}
          fillOpacity="0.4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.3774 11.9525L23.8647 6.05111C23.1178 5.46445 22.0317 5.58789 21.4388 6.32683L11.7762 18.3685C11.1832 19.1075 11.308 20.1821 12.0548 20.7688L19.5675 26.6702C20.3144 27.2569 21.4005 27.1334 21.9935 26.3945L31.6561 14.3528C32.249 13.6138 32.1243 12.5392 31.3774 11.9525ZM23.984 5.90245C23.1542 5.2506 21.9474 5.38776 21.2885 6.2088L11.6259 18.2505C10.9671 19.0716 11.1057 20.2656 11.9355 20.9174L19.4483 26.8188C20.2781 27.4707 21.4849 27.3335 22.1437 26.5125L31.8063 14.4708C32.4652 13.6497 32.3265 12.4557 31.4967 11.8039L23.984 5.90245Z"
          fill={`url(#linear-gradient-5-${uniqueIdentifier})`}
        />
        <path
          d="M21.2885 6.2088C21.9474 5.38776 23.1542 5.2506 23.984 5.90245L31.4967 11.8039C32.3265 12.4557 32.4652 13.6497 31.8063 14.4708L29.3847 17.4886L18.8669 9.22666L21.2885 6.2088Z"
          fill="#EB902A"
        />
        <CardInnerShadow>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M31.1388 12.2499L23.6261 6.34844C23.0452 5.89214 22.2005 5.98815 21.7393 6.56289L19.6755 9.13476L29.2918 16.6886L31.3556 14.1167C31.8167 13.542 31.7197 12.7062 31.1388 12.2499ZM23.984 5.90245C23.1542 5.2506 21.9474 5.38776 21.2885 6.2088L18.8669 9.22666L29.3847 17.4886L31.8063 14.4708C32.4652 13.6497 32.3265 12.4557 31.4967 11.8039L23.984 5.90245Z"
            fill={`url(#linear-gradient-6-${uniqueIdentifier})`}
          />
        </CardInnerShadow>
        <CardInnerShadow>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.4128 20.3228L19.9255 26.2242C20.4234 26.6153 21.1475 26.533 21.5428 26.0404L25.3601 21.2831L16.0443 13.9654L12.227 18.7226C11.8317 19.2152 11.9149 19.9316 12.4128 20.3228ZM19.5676 26.6702C20.3145 27.2568 21.4006 27.1334 21.9935 26.3945L26.1688 21.1912L15.9515 13.1653L11.7763 18.3685C11.1833 19.1075 11.3081 20.1821 12.0549 20.7687L19.5676 26.6702Z"
            fill={`url(#linear-gradient-7-${uniqueIdentifier})`}
          />
        </CardInnerShadow>
        <path d="M18.8672 9.22705L29.385 17.489L28.9834 17.9895L18.4656 9.72755L18.8672 9.22705Z" fill="#8B5417" />
        <path d="M19.1348 8.89355L29.6526 17.1555L29.3848 17.4892L18.867 9.22722L19.1348 8.89355Z" fill="#F6BD7C" />
      </OrangeCard>
      <BlueCard filter={`url(#background-blue-card-shadow-${uniqueIdentifier})`}>
        <path
          d="M11.7708 3.80683C12.0956 2.80894 13.1765 2.26049 14.1851 2.58182L23.3159 5.49095C24.3244 5.81228 24.8788 6.88172 24.554 7.8796L19.7908 22.5149C19.466 23.5128 18.3851 24.0612 17.3766 23.7399L8.24573 20.8308C7.23717 20.5094 6.68284 19.44 7.00762 18.4421L11.7708 3.80683Z"
          fill="white"
        />
        <path
          d="M11.7708 3.80683C12.0956 2.80894 13.165 2.25684 14.1595 2.57368L23.3425 5.49942C24.3369 5.81626 24.8798 6.88204 24.555 7.87993L19.8506 22.3345C19.5258 23.3324 18.4564 23.8845 17.462 23.5677L8.27896 20.6419C7.28452 20.3251 6.74165 19.2593 7.06642 18.2614L11.7708 3.80683Z"
          fill={`url(#linear-gradient-8-${uniqueIdentifier})`}
          fillOpacity="0.4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.2571 5.67163L14.1262 2.76251C13.2185 2.47331 12.2457 2.96691 11.9535 3.86501L7.19023 18.5003C6.89794 19.3984 7.39683 20.3609 8.30453 20.6501L17.4354 23.5592C18.3431 23.8484 19.3159 23.3548 19.6082 22.4567L24.3714 7.82142C24.6637 6.92332 24.1648 5.96083 23.2571 5.67163ZM14.1851 2.58182C13.1765 2.26049 12.0956 2.80894 11.7708 3.80683L7.00762 18.4421C6.68284 19.44 7.23717 20.5094 8.24573 20.8308L17.3766 23.7399C18.3851 24.0612 19.466 23.5128 19.7908 22.5149L24.554 7.8796C24.8788 6.88172 24.3244 5.81228 23.3159 5.49095L14.1851 2.58182Z"
          fill={`url(#linear-gradient-9-${uniqueIdentifier})`}
        />
        <path
          d="M11.7708 3.80683C12.0956 2.80894 13.1765 2.26049 14.1851 2.58182L23.3159 5.49095C24.3244 5.81228 24.8788 6.88172 24.554 7.8796L23.3602 11.5475L10.5771 7.47468L11.7708 3.80683Z"
          fill="#0072B7"
        />
        <CardInnerShadow>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.1395 6.033L14.0086 3.12387C13.3026 2.89894 12.546 3.28286 12.3187 3.98137L11.3014 7.10718L22.9888 10.8309L24.0061 7.70505C24.2335 7.00653 23.8455 6.25793 23.1395 6.033ZM14.1851 2.58182C13.1765 2.26049 12.0956 2.80894 11.7708 3.80683L10.5771 7.47468L23.3602 11.5475L24.554 7.8796C24.8788 6.88172 24.3244 5.81228 23.3159 5.49095L14.1851 2.58182Z"
            fill={`url(#linear-gradient-10-${uniqueIdentifier})`}
          />
        </CardInnerShadow>
        <CardInnerShadow>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.48114 20.1087L17.612 23.0178C18.2171 23.2106 18.8656 22.8815 19.0605 22.2828L20.9423 16.501L9.62004 12.8936L7.73828 18.6755C7.54341 19.2742 7.87601 19.9159 8.48114 20.1087ZM17.4356 23.5599C18.3433 23.8491 19.3161 23.3554 19.6083 22.4574L21.6665 16.1335L9.24861 12.1771L7.19043 18.5009C6.89813 19.399 7.39702 20.3615 8.30473 20.6507L17.4356 23.5599Z"
            fill={`url(#linear-gradient-11-${uniqueIdentifier})`}
          />
        </CardInnerShadow>
        <path d="M10.5771 7.47559L23.3603 11.5484L23.1623 12.1567L10.3792 8.08388L10.5771 7.47559Z" fill="#073A58" />
        <path d="M10.7095 7.06885L23.4926 11.1416L23.3606 11.5472L10.5775 7.47438L10.7095 7.06885Z" fill="#7DC5F0" />
      </BlueCard>
      <defs>
        <filter
          id={`background-card-shadow-${uniqueIdentifier}`}
          x="0.0146484"
          y="1.64258"
          width="15.5479"
          height="21.2437"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_757_46985" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_757_46985" result="shape" />
        </filter>
        <filter
          id={`background-orange-card-shadow-${uniqueIdentifier}`}
          x="10.21"
          y="4.98438"
          width="23.0181"
          height="23.7461"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_757_46985" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_757_46985" result="shape" />
        </filter>
        <filter
          id={`background-blue-card-shadow-${uniqueIdentifier}`}
          x="4.91455"
          y="0.984375"
          width="21.7344"
          height="25.3472"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_757_46985" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_757_46985" result="shape" />
        </filter>
        <linearGradient
          id={`linear-gradient-0-${uniqueIdentifier}`}
          x1="7.95669"
          y1="2.17953"
          x2="7.81421"
          y2="21.161"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#050D55" stopOpacity="0.37" />
        </linearGradient>
        <linearGradient
          id={`linear-gradient-1-${uniqueIdentifier}`}
          x1="7.86157"
          y1="2.17882"
          x2="7.71766"
          y2="21.3501"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.416667" stopColor="#F8787E" stopOpacity="0" />
          <stop offset="1" stopColor="#F8787E" stopOpacity="0.41" />
        </linearGradient>
        <linearGradient
          id={`linear-gradient-2-${uniqueIdentifier}`}
          x1="7.86157"
          y1="2.17882"
          x2="7.82319"
          y2="7.29115"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.75" />
          <stop offset="0.99537" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={`linear-gradient-3-${uniqueIdentifier}`}
          x1="7.71651"
          y1="21.1605"
          x2="7.77224"
          y2="13.7367"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.75" />
          <stop offset="0.99537" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={`linear-gradient-4-${uniqueIdentifier}`}
          x1="27.8148"
          y1="8.91168"
          x2="16.0411"
          y2="23.9001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#050D55" stopOpacity="0.37" />
        </linearGradient>
        <linearGradient
          id={`linear-gradient-5-${uniqueIdentifier}`}
          x1="27.7403"
          y1="8.85316"
          x2="15.8489"
          y2="23.9914"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.333333" stopColor="#EB902A" stopOpacity="0.12" />
          <stop offset="1" stopColor="#EB902A" stopOpacity="0.35" />
        </linearGradient>
        <linearGradient
          id={`linear-gradient-6-${uniqueIdentifier}`}
          x1="27.7403"
          y1="8.85316"
          x2="24.5693"
          y2="12.89"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.75" />
          <stop offset="0.99537" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={`linear-gradient-7-${uniqueIdentifier}`}
          x1="15.8113"
          y1="23.7195"
          x2="20.4161"
          y2="17.8573"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.75" />
          <stop offset="0.99537" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={`linear-gradient-8-${uniqueIdentifier}`}
          x1="18.841"
          y1="4.06523"
          x2="13.073"
          y2="22.1693"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#050D55" stopOpacity="0.37" />
        </linearGradient>
        <linearGradient
          id={`linear-gradient-9-${uniqueIdentifier}`}
          x1="18.7505"
          y1="4.03639"
          x2="12.9247"
          y2="22.3215"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.333333" stopColor="#DBF1FF" stopOpacity="0.51" />
          <stop offset="1" stopColor="#7DC5F0" stopOpacity="0.63" />
        </linearGradient>
        <linearGradient
          id={`linear-gradient-10-${uniqueIdentifier}`}
          x1="18.7505"
          y1="4.03639"
          x2="17.1969"
          y2="8.91242"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.75" />
          <stop offset="0.99537" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={`linear-gradient-11-${uniqueIdentifier}`}
          x1="12.8701"
          y1="22.1053"
          x2="15.1261"
          y2="15.0246"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.75" />
          <stop offset="0.99537" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default MPCardProgressSvgAsComponent;
